module.exports = __webpack_public_path__ + "static/media/Bettair_Logo.f9da9110.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Bettair_Logo.svg
// module id = 294
// module chunks = 0